import type { CurrenciesMap, ValuesMap, LangsFormatMap } from "./dynamicVariables.d";

export const currenciesMap: CurrenciesMap = {
  USD: "$",
  EUR: "€",
  US$: "US$",
  "$ US": "$ US",
  GBP: "£",
  euro: "euro",
  евро: "евро",
  BRL: "R$",
  欧元: "欧元",
};

export const langsFormatMap: LangsFormatMap = {
  "en-int,en,en-gb,en-ie,en-au,en-nz,en-in,en-ca": { format: "<currency><value>", separator: "," },
  bg: { format: "<value> <currency>", separator: "," },
  "pt-br,nl": { format: "<currency> <value>", separator: "." },
  "de,de-at,de-ch,ro,el,it,ro-md,tr": { format: "<value> <currency>", separator: "." },
  "fi,sv,hu,fr-ca": { format: "<value> <currency>", separator: " " },
  fallback: { format: "<value> <currency>", separator: "" },
};

export const valuesMap: ValuesMap = {
  "{{compensation_value}}": {
    en: { value: 700, currency: "USD" },
    "en-gb": { value: 520, currency: "GBP" },
    "en-ca,en-in,en-nz,en-au": { value: 700, currency: "US$" },
    "fr-ca": { value: 700, currency: "$ US" },
    "pt-br": { value: 10000, currency: "BRL" },
    nb: { value: 600, currency: "euro" },
    ru: { value: 600, currency: "евро" },
    "zh-cn": { value: 600, currency: "欧元" },
    fallback: { value: 600, currency: "EUR" },
  },
  "{{luggage_compensation_value}}": {
    en: { value: 1700, currency: "USD" },
    "en-gb": { value: 1200, currency: "GBP" },
    "en-ca,en-in,en-au,en-nz": { value: 1700, currency: "US$" },
    "fr-ca": { value: 1700, currency: "$ US" },
    "pt-br": { value: 9000, currency: "BRL" },
    ru: { value: 1400, currency: "евро" },
    nb: { value: 1400, currency: "euro" },
    "zh-cn": { value: 1400, currency: "欧元" },
    fallback: { value: 1400, currency: "EUR" },
  },
  "{{extra_expenses_compensation_value}}": {
    en: { value: 7000, currency: "USD" },
    "en-gb": { value: 5300, currency: "GBP" },
    "en-ca,en-in,en-au,en-nz": { value: 7000, currency: "US$" },
    "fr-ca": { value: 7000, currency: "$ US" },
    "pt-br": { value: 39000, currency: "BRL" },
    nb: { value: 6000, currency: "euro" },
    ru: { value: 6000, currency: "евро" },
    "zh-cn": { value: 6000, currency: "欧元" },
    fallback: { value: 6000, currency: "EUR" },
  },
  "{{commission_value}}": {
    en: { value: 700, currency: "USD" },
    "en-gb": { value: 520, currency: "GBP" },
    "en-ca,en-in,en-au,en-nz": { value: 700, currency: "US$" },
    "fr-ca": { value: 700, currency: "$ US" },
    "pt-br": { value: 10000, currency: "BRL" },
    nb: { value: 600, currency: "euro" },
    ru: { value: 600, currency: "евро" },
    "zh-cn": { value: 600, currency: "欧元" },
    fallback: { value: 600, currency: "EUR" },
  },
  "{{ah_price_value}}": {
    "en-gb,en-ie,en,en-int": { value: 19.99, currency: "EUR" },
    "en-ca,en-in,en-au,en-nz": { value: 19.99, currency: "US$" },
    "zh-cn": { value: 19.99, currency: "欧元" },
    nb: { value: "19,99", currency: "euro" },
    ru: { value: "19,99", currency: "евро" },
    fallback: { value: "19,99", currency: "EUR" },
  },
  "{{ec261_compensation}}": {
    en: { value: 700, currency: "USD" },
    "en-gb": { value: 520, currency: "GBP" },
    "en-ca,en-in,en-au,en-nz": { value: 700, currency: "US$" },
    "fr-ca": { value: 700, currency: "$ US" },
    "pt-br": { value: 3000, currency: "BRL" },
    nb: { value: 600, currency: "euro" },
    "zh-cn": { value: 600, currency: "欧元" },
    ru: { value: 600, currency: "евро" },
    fallback: { value: 600, currency: "EUR" },
  },
  "{{brazil_compensation}}": {
    en: { value: 1800, currency: "USD" },
    "en-gb": { value: 1500, currency: "GBP" },
    "en-in,en-ca,en-au,en-nz": { value: 1800, currency: "US$" },
    "pt-br": { value: 10000, currency: "BRL" },
    "fr-ca": { value: 1800, currency: "$ US" },
    nb: { value: 1800, currency: "euro" },
    ru: { value: 1800, currency: "евро" },
    "zh-cn": { value: 1800, currency: "欧元" },
    fallback: { value: 1800, currency: "EUR" },
  },
  "{{uk261_compensation}}": {
    en: { value: 600, currency: "USD" },
    "en-gb": { value: 520, currency: "GBP" },
    "pt-br": { value: 3000, currency: "BRL" },
    "en-ca,en-in,en-au,en-nz": { value: 600, currency: "US$" },
    "fr-ca": { value: 600, currency: "$ US" },
    nb: { value: 600, currency: "euro" },
    ru: { value: 600, currency: "евро" },
    "zh-cn": { value: 600, currency: "欧元" },
    fallback: { value: 600, currency: "EUR" },
  },
  "{{passengers_compensated}}": {
    "en-int,en,en-gb,en-ie,en-ca,en-in,en-au,en-ez,en-nz": { value: "1.5" },
    "zh-cn": { value: "150" },
    fallback: { value: "1,5" },
  },
  "{{br_flight_delay}}": {
    fallback: { value: "2" },
  },
  "{{nr_airhelpers}}": {
    fallback: { value: "350" },
  },
  "{{nr_languages}}": {
    fallback: { value: "18" },
  },
  "{{nr_ahp_purchases}}": {
    fallback: { value: "3.4" },
  },
  "{{nr_flights_checked}}": {
    fallback: { value: "12" },
  },
};
